import { useState } from 'react';
import { ChevronRight, FileText, Trash2 } from 'react-feather';
import PageGridItem from '../../Shared/Page/PageGridItem';
import Table from '../../../components/Table/Table';
import GenericListHeader from '../../Shared/TablesAndLists/GenericListHeader';
import FlexWrapper from '../../FlexWrapper';

const AssociatedFundsList = ({ editMode, fundsUsed, addFundUsed, removeFundUsed, allFunds }) => {
	const [filteredFundsUsed, setFilteredFundsUsed] = useState([]);
	const [hasSearchTerm, setHasSearchTerm] = useState(false);
	const allSelectableFunds = allFunds.filter(fund => !fundsUsed.some(usedFund => usedFund?.fundName === fund?.fundName));

	const header = `Template Coverage`

	const widths = ["1fr", "60px"];
	const dataMap = (data) => {
		console.log("Mapping data ", data);

		return data.filter(x => x).map((fund, idx) => {
			return (
				<tr key={idx}>
					<td style={{ height: "100%", cursor: "pointer" }} >
						<FlexWrapper align={"center"}>
							{fund.fundName}
						</FlexWrapper>
					</td>
					<td style={{ height: "100%", cursor: "pointer" }} >
						<FlexWrapper align={"center"} justify="space-between" >
							<Trash2
								onClick={(e) => {
									e.stopPropagation();
									removeFundUsed(fund)
								}}
								color='#E66780'
								style={editMode ? { opacity: 1 } : { opacity: 0.5 }}
								size={20}
							/>
							<ChevronRight />
						</FlexWrapper>
					</td>
				</tr>
			);
		});
	}

	return (
		<>
			<PageGridItem col="1 / span 6" gap="m" direction="col">
				<GenericListHeader
					setHasSearchTerm={setHasSearchTerm}
					onSearchSelect={(list) => editMode && addFundUsed(list)}
					header={header}
					headerOptions={[{ label: header, value: header }]}
					onHeaderOptionSelect={null}
					addableLists={allSelectableFunds.map((fund) => ({ value: fund, label: fund?.fundName || 'Invalid fund' }))}
					userLists={fundsUsed}
					setFilteredUserLists={setFilteredFundsUsed}
					hideFilterInput
					icon={<FileText />}
					disableAddInput={!editMode}
				/>
				<Table colWidths={widths} dataMap={dataMap(hasSearchTerm ? filteredFundsUsed : fundsUsed)} />
			</PageGridItem>
		</>
	);
}

export default AssociatedFundsList;